// Sticky Collection Filters JavaScript
(function() {
  'use strict';
  
  let lastScrollTop = 0;
  const scrollThreshold = 50;
  let isScrolling = false;
  let filterBarOriginalTop = 0;
  let isSticky = false;
  
  const filterBar = document.querySelector('.collection__filters');
  const collectionContent = document.querySelector('.collection__content');
  
  if (!filterBar) return;
  
  function calculateOriginalPosition() {
    // Reset to original position to get accurate measurement
    filterBar.classList.remove('sticky', 'scroll-up', 'scroll-down');
    if (collectionContent) {
      collectionContent.classList.remove('filters-sticky');
    }
    
    const rect = filterBar.getBoundingClientRect();
    filterBarOriginalTop = rect.bottom + window.pageYOffset;
  }
  
  function handleScroll() {
    if (isScrolling) return;
    
    isScrolling = true;
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - lastScrollTop;
      
      // Check if we should make the filter bar sticky
      if (scrollTop >= filterBarOriginalTop && !isSticky) {
        // Make sticky
        isSticky = true;
        filterBar.classList.add('sticky', 'scroll-up');
        if (collectionContent) {
          collectionContent.classList.add('filters-sticky');
        }
      } else if (scrollTop < filterBarOriginalTop && isSticky) {
        // Remove sticky
        isSticky = false;
        filterBar.classList.remove('sticky', 'scroll-up', 'scroll-down');
        if (collectionContent) {
          collectionContent.classList.remove('filters-sticky');
        }
      }
      
      // Handle show/hide when sticky
      if (isSticky && Math.abs(scrollDelta) > scrollThreshold) {
        if (scrollDelta > 0) {
          // Scrolling down - hide filter bar
          filterBar.classList.add('scroll-down');
          filterBar.classList.remove('scroll-up');
        } else {
          // Scrolling up - show filter bar
          filterBar.classList.add('scroll-up');
          filterBar.classList.remove('scroll-down');
        }
        lastScrollTop = scrollTop;
      }
      
      isScrolling = false;
    });
  }
  
  // Throttled scroll event listener
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
      setTimeout(() => { ticking = false; }, 16);
    }
  }
  
  // Handle window resize
  function onResize() {
    calculateOriginalPosition();
  }
  
  // Initialize
  function init() {
    // Calculate initial position
    calculateOriginalPosition();
    
    // Add scroll event listener
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
  });
})();